module.exports = __webpack_public_path__ + "img/change.c5b22835.jpg";